<template>
  <div>
    <div class="hide-content"></div>
    <div class="refuse-modal">
      <h4 class="mb-0 color-grey" v-if="amount > 0">
        {{ $t("refuse.title_some", { amount: amount }) }}
      </h4>
      <!-- <h4 class="mb-0 color-grey" v-if="amount === -1">{{ $t('refuse.title_all') }}</h4> -->
      <p class="mb-0 color-white">{{ $t("refuse.enter_reason") }}</p>

      <textarea
        :class="valid ? '' : 'red-textarea'"
        cols="30"
        rows="9"
        v-model="reason"
        :placeholder="$t('refuse.enter_reason_ph')"
      ></textarea>

      <p class="refund-warn" v-if="will_refund">
        {{ $t('refuse.refund_warning') }}
      </p>

      <div class="actions">
        <QueueButton variant="accept" @click="cancel">{{
          $t("refuse.cancel")
        }}</QueueButton>
        <QueueButton variant="cancel" class="float-right" @click="confirm">{{
          $t("refuse.confirm")
        }}</QueueButton>
      </div>
    </div>
  </div>
</template>

<script>
import QueueButton from "@/components/QueueButton.vue";

export default {
  props: {
    amount: {
      type: Number,
      default: -1,
    },
    will_refund: Boolean
  },
  data() {
    return {
      reason: null,
      custom: null,

      valid: true,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      if (!this.reason || this.reason.length < 3) {
        this.valid = false;
        return;
      }

      this.$emit("confirm", this.reason);
    },
  },
  mounted() {
    this.toggleGlobalScrolling(true);
  },
  beforeDestroy() {
    this.toggleGlobalScrolling(false);
  },
  components: {
    QueueButton,
  },
};
</script>

<style scoped>
.refuse-modal {
  background: #1d1d1b;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2.5vh;
  position: fixed;
  top: 50%;
  padding: 2.5vh;
  transform: translateY(-50%);
  width: 90%;
  z-index: 10;
  left: 5%;
}

.hide-content {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 2;
  overflow: hidden;
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.4);
  opacity: 1;
  top: 0;
  left: 0;
}

.refuse-modal p {
  line-height: normal;
  font-size: 2.5vh;
}

.actions {
  display: flex;
  justify-content: space-between;
  padding: 2.5vh 0 0;
  width: 90%;
  margin: 0 auto;
  left: 0;
  right: 0;
  position: absolute;
  margin-top: 3vh;
}

.actions button {
  width: 48%;
}

.btn-accept,
.btn-cancel {
  padding: 15px 20px;
  border-radius: 25px;
  border: 0;
  color: white;
}

.btn-cancel {
  background: #e2223b;
}

.btn-accept {
  background: #129b81;
}

h4 {
  color: #a4a3a1;
  font-size: 2.5vh;
  line-height: 3vh;
  margin-bottom: 0;
  width: 60vw;
}

label {
  font-size: 18px;
  margin: 0 0 0 5px;
}

textarea {
  border-radius: 10px;
  outline: none;
  display: block;
  background: transparent;
  margin: 0 auto;
  width: 100%;
  margin-top: 1.8vh;
  padding: 0.5vh 0 0 2vw;
  color: #ededed;
}

.refund-warn {
  color: #e2223b;
  margin-top: 0.5vh;
  padding: 0.5vh 0 0 2vw;
  font-size: 2vh !important;
  margin-bottom: 0;
}

.red-textarea {
  border: 1px solid #e2223b;
}
@media (min-width: 768px) {
  div.refuse-modal {
    width: 23.264vw;
    /* height: 21.25vw; */
    left: 38.403vw;
    padding: 1.389vw;
    border-radius: 1.389vw;
  }

  .refund-warn {
    padding: 0;
  }

  .refuse-modal p {
    font-size: 1.389vw;
    line-height: 1.597vw;
  }
  textarea {
    height: 15.486vw;
    font-size: 0.903vw;
    line-height: 0.903vw;
    padding: 0.694vw;
  }
  div.actions {
    padding: 0;
    margin-top: 2.778vw;
    width: 23.264vw;
  }
  .actions button {
    min-width: 0;
    width: 10.903vw !important;
  }
}
</style>
